<script lang="ts" setup>
import { MegaphoneIcon } from 'lucide-vue-next'

const { user } = storeToRefs(useAuthStore())
const { t } = useI18n()

const isPSOAClient = computed(() => [121, 124, 56, 126, 97].includes(Number(user.value.client.id)))
</script>

<template>
  <div
    v-if="isPSOAClient"
    class="bg-primary p-8 rounded-xl flex gap-2 items-center text-primary-content"
  >
    <MegaphoneIcon :size="24" />
    <span class="text-lg font-bold">
      {{ t('rounds.collect_psoa_informations') }}
    </span>
    <span class="text-xs text-base-primary/70">
      {{ t('rounds.collect_psoa_informations_subtitle') }}
    </span>
  </div>
</template>
